<template>
  <div class="m-search">
    <div class="m-header">
      <a-input-search
        ref="input"
        placeholder="搜索姓名"
        :allow-clear="true"
        @search="handleSearch"
        @change="handleChange"
      />
      <router-link
        to="/"
        class="m-back"
      >
        取消
      </router-link>
    </div>
    <div
      class="m-search-tips"
    >
      {{ searchTips }}
    </div>
    <div class="searchList">
      <div
        v-for="(result,n) in searchResult"
        :key="n"
        class="m-infos"
        @click="handleSelect(result.userId)"
      >
        <avatar :src="result.image" />
        <div>
          <div>
            <span class="m-infos-name">{{ result.userName }}</span>
            <span class="m-infos-posi">{{ result.duty }}</span>
          </div>
          <div class="m-infos-dep">
            {{ result.departmentNameList[result.departmentNameList.length-1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { setDDTitle } from '@utils'

import { Input, message } from 'ant-design-vue'
import Avatar from '@components/avatar/index.vue'
import debounce from 'lodash/debounce'

Vue.use(Input)

export default {
  name: 'OKRSearch',
  components: {
    Avatar,
  },
  data() {
    this.handleSearch = debounce(this.handleSearch, 1000)
    return {
      userId: null,
      // 三种提示文案，输入内容返回数据提示“你可能想找”，若找不到提示“报告老板，查无此人”
      searchTips: '例如：邹依依',
      searchResult: [],
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.userId,
    }),
  },
  beforeCreate() {
    setDDTitle('查询他人的业绩目标')
    document.title = '查询他人的业绩目标'
  },
  mounted () {
    // 进入页面文本框获取焦点
    this.$refs.input.focus()
  },
  methods: {
    async handleSearch(value) {
      if (!value) {
        this.searchResult = []
      } else {
        try {
          const searchResult = await this.$api.okr.search({
            userName: value,
          })
          if (searchResult.length === 0) {
            this.searchTips = '报告老板，查无此人'
            return
          }
          this.searchTips = '你可能想找'
          this.$set(this, 'searchResult', searchResult || [])
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        }
      }
    },
    // 点击查询结果新开页面打开该用户OKR列表
    handleSelect(key) {
      if (this.currentUser === key) {
        this.$router.push({
          name: 'MyOKR',
        })
      } else {
        this.$router.push({
          name: 'OthersOKR',
          params: { userId: key },
        })
      }
    },
    handleChange(e) {
      if (e.target.value) {
        this.handleSearch(e.target.value)
      } else {
        this.searchTips = '例如：邹依依'
        this.searchResult = []
      }
    },
  },

}
</script>

<style lang="less">
.m-search{display: flex; flex-direction:column; width:100%; height: 100vh; overflow: hidden;}
.searchList{flex:1; overflow-y: auto; -webkit-overflow-scrolling: touch;}
.m-header{height: .5rem; display: flex; justify-content: space-between; align-items:center; padding: 0 .2rem; background-color: #fff;}
.m-back{display: inline-block; width:.5rem; color:#006EF0; font-size: .14rem; text-align: right;}
/* 覆盖antd样式 */
.ant-input{height:.4rem; border-radius: .2rem; border:none; background: #F5F5F5 url('~@images/mIco-search2.png') no-repeat .08rem center;
background-size: .24rem auto; padding-left: .36rem; padding-right:0;}
/* 覆盖antd样式 */
.anticon-search{display: none;}
.m-search-tips{height: .5rem; line-height: .5rem; padding: 0 .2rem; background-color: #fff; margin-top: 1px;  font-size:.14rem; color:#999;}
.m-infos{display: flex; flex-direction:row; align-items:center;  background-color: #fff; margin-top: 1px; padding: .2rem;
img{margin-right: .16rem;}
}
.m-infos-name{font-weight: bold; font-size: .14rem;}
.m-infos-posi{ font-size: .14rem; padding-left: .04rem;}
.m-infos-dep{ font-size: .11rem; color:#999;}
</style>
